import styled from 'styled-components';
import { MASKED_TEXT_CLASS } from 'analytics';

export const PatientName = styled.div.attrs({
  className: `text-sm font-semibold text-primary leading-5 ${MASKED_TEXT_CLASS}`,
})``;

export const ConsultationTitle = styled.div.attrs({
  className: 'text-sm font-semibold text-foreground leading-5',
})``;

export const ChiefComplaint = styled.div.attrs({
  className: `text-xs leading-4 text-muted-foreground ${MASKED_TEXT_CLASS}`,
})``;

export const PatientInfoContainer = styled.div.attrs({
  className: 'flex flex-row items-start justify-between w-full',
})``;

export const PatientInfoContent = styled.div.attrs({
  className: 'flex flex-col gap-0',
})``;

export const VisitReasonChip = styled.div.attrs({
  className: `bg-[#6B84C4] text-white text-xs font-medium px-2 py-0.5 rounded-md self-end mb-0.5 ${MASKED_TEXT_CLASS}`,
})``;
